import React from "react";
import CodeTabBlock from "./CodeTabBlock";

const CodeTabsWleSignature = () => {
  const tabName = "WleSignature";
  const tabContent = {
    Python: `
    import hmac 
    import hashlib 
    signature = hmac.new(secret, msg=request_string, digestmod=hashlib.sha256).hexdigest()
    `,
    JavaScript: `
    const crypto = require('crypto'); var signature =
    crypto.createHmac('sha256',
    secret).update(requestString).digest('hex');
    `,
    Ruby: `
    require 'openssl' digest = OpenSSL::Digest.new('sha256') signature =
    OpenSSL::HMAC.hexdigest(digest, secret, request_string)
    `,
    PHP: `
    $signature=hash_hmac('sha256', $secret, false);
    `
  };
  return (
    <CodeTabBlock tabName={tabName} tabContent={tabContent}/>
  );
};

export default CodeTabsWleSignature;
